export default {
  methods: {
    /**
     * Opens a modal by name (in data -> modals.[name])
     */
    openModal(name) {
      this.modals[name].visible = true;
      return true;
    },
    /**
     * Hide a modal by name
     * @param string name
     */
    hideModal(name) {
      this.modals[name].visible = false;
    },
  },
};
